import { DraftImpactEntryVm } from '@/features/dashboard/bookingChanges/types/ChangeViewModel.ts';
import MoneyAmountList from '@/features/dashboard/bookingChanges/components/primitives/MoneyAmountList.tsx';
import { InfoCardRow } from '@/components/ui/InfoCard.tsx';

interface DraftImpactPersonRowProps {
  entry: DraftImpactEntryVm;
}

/** Udział jednej osoby w bilansie szkicu — kwota albo „bez wpływu”. */
const DraftImpactPersonRow = ({ entry }: DraftImpactPersonRowProps) => (
  <InfoCardRow label={entry.label}>
    {entry.withoutImpact ? (
      <span className="text-neutral-400">bez wpływu</span>
    ) : (
      <span className="tabular-nums text-ink">
        <MoneyAmountList values={entry.delta} variant="signed" />
      </span>
    )}
  </InfoCardRow>
);

export default DraftImpactPersonRow;
